import React from "react";

import ActionButton from "./ActionButton";

const ActionButtons = ({ onConfirm, onClose }) => (
  <>
    <ActionButton key="yes" onClick={onConfirm}>
      Yes
    </ActionButton>
    <ActionButton key="no" onClick={onClose}>
      No
    </ActionButton>
  </>
);

export default ActionButtons;
